/**
 * Created by Jerker Nord on 2019-02-19.
 */
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {CubicHermiteSpline} from "../helper/CubicHermiteSpline";

export class TractorBetLineEvent extends BetLineEvent {
    static readonly ABORT_ALL_BET_LINES:string = "abortAllBetLines";
}

export class AnimatedMeshRope extends PIXI.Container {

    private _textures:PIXI.Texture[] = [];
    private _curvePoints:number[][];
    private _curveSmoothness:number;
    private _ropePoints:PIXI.Point[];
    private _animateTimeline:TimelineLite;
    private _textureCounter:number;
    private _numberOfTextures:number;
    private _winAnimation:PIXI.SimpleRope;
    private _currentBetWins:number = 0;

    constructor() {
        super();

        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:SpinEvent) => {
            //console.log("spin start");
            this.abort();
        });

        EventHandler.addEventListener(this, TractorBetLineEvent.ABORT_ALL_BET_LINES, (event:GameEvent) => this.abort(event.params[0]));  // TODO: enabling this in current state will cuase excessive blinking on toggle
    }

    public setCurrentBetWins(amount:number):void {
        this._currentBetWins = amount;
    }

    /**
     *
     * @param textures
     * @param curvePoints
     * @param curveSmoothness
     */
    public createAnimatedMeshRope(textures:PIXI.Texture[], curvePoints:number[][], curveSmoothness:number = 2):void {
        this._textures = textures;
        this._curvePoints = curvePoints;
        this._curveSmoothness = curveSmoothness / 1000;

        this._numberOfTextures = this._textures.length;
        this._textureCounter = 0;

        this._ropePoints = [];
        let point:number[];

        let tangents:number[][] = [];
        let tempX:number;
        let tempY:number;
        for(let i:number = 0; i < this._curvePoints.length; i++) {
            if(i == (this._curvePoints.length - 1)) {
                this._curvePoints[i][0] += 65;
            }
            tempY = Math.floor(this._curvePoints[i][1] / 30);
            tempX = Math.floor(this._curvePoints[i][0] / 2.9);//Lower value = bigger curves

            tangents.push([tempX, tempY]);
        }

        for(let t = 0; t < 1; t += this._curveSmoothness) {
            point = CubicHermiteSpline.interpolate(t, this._curvePoints, tangents);
            this._ropePoints.push(new PIXI.Point(point[0], point[1]));
        }
        this._winAnimation = new PIXI.SimpleRope(this._textures[this._textureCounter], this._ropePoints);

        // Magic numbers, for stretching the betline
        //this._winAnimation.scale.set(1.15, 1);
        //this._winAnimation.x = this._winAnimation.x - 90;
        this._winAnimation.blendMode = PIXI.BLEND_MODES.SCREEN;

        //const colorMatrix = new PIXI.filters.ColorMatrixFilter();
        //colorMatrix.blendMode = PIXI.BLEND_MODES.SCREEN;

        // HUE ROT. ANIMATION
        //this._winAnimation.filters = [colorMatrix];
        //colorMatrix.hue(-235);
        let hueCounter:number = -235;
        /*new TimelineMax({repeat: -1}).add( // yoyo
            () => {
                if(hueCounter > -115) { // -165
                    hueCounter = -235;
                }
                colorMatrix.hue(hueCounter-=20, false); // +=5
            }, 0.033);*/


        this.addChild(this._winAnimation);

        const updatePause:number = 0.033;
        this._animateTimeline = new TimelineMax({repeat : -1, paused : true});
        this._animateTimeline.add(() => this.updateTexture(), "+" + updatePause);
    }

    public getAnimatedMeshRopeTL():TimelineLite {
        const animatedMeshRopeTL:TimelineLite = new TimelineLite({});
        animatedMeshRopeTL.add(() => (this._winAnimation.visible = true));
        animatedMeshRopeTL.add(TweenLite.to(this._winAnimation, 0.2, {alpha : 1}));
        animatedMeshRopeTL.add(() => (this._animateTimeline.restart()));

        return animatedMeshRopeTL;
    }

    public stop():void {
        //console.log("BL STOP CALLED");
        new TimelineLite().add(TweenLite.to(this._winAnimation, 0.2, {alpha : 0})).
            //add(() => this._winAnimation.visible = false).
            add(() => {
                //this._winAnimation.visible = false;
                this._animateTimeline.pause();
                this._animateTimeline.kill();
            });
    }

    public abort(hard:boolean = false):void {
        if(this._animateTimeline) {
            if(!hard) {
                new TimelineLite().add(TweenLite.to(this._winAnimation, 0.15, {alpha : 0})).
                    //add(() => this._winAnimation.visible = false).
                    add(() => {
                        this._winAnimation.visible = false;
                        this._animateTimeline.pause();
                        this._animateTimeline.kill();
                    });
            } else {
                this._winAnimation.visible = false;
                this._animateTimeline.pause();
                this._animateTimeline.kill();
            }
        }
    }

    private updateTexture():void {
        this._textureCounter++;
        if(this._textureCounter < this._numberOfTextures) {
            this._winAnimation.texture = this._textures[this._textureCounter];
        } else {
            if(this._currentBetWins > 1) {
                this.stop();
            }
            this._textureCounter = 0;
        }
    }
}
